import React from 'react';
import styles from '../styles/empty.module.scss';
import { ReactComponent as EmptyIcon } from '@ui-kit/icons/empty.svg';

export default function Empty(props: {
  children: React.ReactNode;
  icon?: JSX.Element;
  style?: React.CSSProperties;
}) {
  return (
    <div className={styles.empty} style={{ margin: '10px', ...props.style }}>
      {props.icon ? props.icon : <EmptyIcon width="120px" height="120px" />}
      <div>{props.children}</div>
    </div>
  );
}
